export default {
  questions: {
    common: {
      dropdownPlaceholder: 'Please select:'
    },
    comments: {
      additionalComments: 'Additional comments',
      enter: 'Enter your text here',
      title: 'Any other comments you would like to share with us?' //Dynamic use

    },
    menuInsight: {
      areYouSureYouWantToClose: 'Are you sure you want to close?',
      theInformationYouHaveEnteredHere: 'The information you have entered here won’t be saved',
      moreCharactersRequired: 'Enter three or more characters to search for your item.'
    },
    nps: {
      notVeryLikely: 'Not very likely',
      sliderDesc: 'Tap below to select a score',
      sliderDirtyDesc: 'Slide to change your score',
      veryLikely: 'Very likely'
    },
    questions: {
      na: 'Not Applicable'
    },
    staff: {
      areYouSureYouWantToClose: 'Are you sure you want to close?',
      theInformationYouHaveEnteredHereWontBeSaved: 'The information you have entered here won’t be saved'
    },
    yesNoWhy: {
      whyIsThat: 'Why is that?'
    },
    saveAndContinue: 'Save & Continue',
    areYouSureYouWantToClose: 'Are you sure you want to close?',
    theInformationYouHaveEnteredHere: 'The information you have entered here won’t be saved'
  }
};